import { flexRender, type HeaderGroup } from '@tanstack/react-table'

import { cn } from '../../utils/cn'
import { TableHead, TableHeader, TableRow, TableSortIcon } from '../_base/Table'

export function DataTableHeader<TData>({
  headerGroups,
  isSticky,
  className
}: {
  headerGroups: HeaderGroup<TData>[]
  isSticky: boolean
  className?: string
}) {
  return (
    <TableHeader sticky={isSticky} className={className}>
      {headerGroups.map(headerGroup => (
        <TableRow key={headerGroup.id}>
          {headerGroup.headers.map(header => {
            const canSort = header.column.getCanSort()
            const isSorted = header.column.getIsSorted()
            const nextSortingOrder = header.column.getNextSortingOrder()
            const isAlignRight = header.column.columnDef.meta?.align === 'right'
            const sticky = header.column.columnDef.meta?.sticky
            const toggleSorting = canSort ? header.column.getToggleSortingHandler() : undefined

            return (
              <TableHead
                key={header.id}
                sticky={sticky}
                className={cn('gap-1', isAlignRight && 'justify-end', canSort && 'cursor-pointer')}
                onClick={toggleSorting}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(header.column.columnDef.header, header.getContext())}
                {canSort && (
                  <TableSortIcon isSorted={isSorted} nextSortingOrder={nextSortingOrder} />
                )}
              </TableHead>
            )
          })}
        </TableRow>
      ))}
    </TableHeader>
  )
}
